import {Section} from 'common/components/items-menu/types';

import {COMPACT_TABLE_LEGEND_LINE_HEIGHT, MAX_SEGMENTS_PER_COMPACT_TABLE_ROW} from './constants';

export function getCardTableChartLegendHeight(legendSections: Section[]): number {
  if (legendSections.length === 0) {
    return 0;
  }

  const selectedSegmentsCount = legendSections.reduce(
    (accu, itemsObj) => accu + itemsObj.items.filter((item) => item.isSelected).length,
    0,
  );
  return Math.ceil(selectedSegmentsCount / MAX_SEGMENTS_PER_COMPACT_TABLE_ROW) * COMPACT_TABLE_LEGEND_LINE_HEIGHT;
}
